/* tslint:disable */
/* eslint-disable */
/**
 * KGH PROJECT API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CompanyBranchDto } from '../models';
// @ts-ignore
import { CompanyBranchDtoPaginatedList } from '../models';
// @ts-ignore
import { CreateCompanyBranchCommand } from '../models';
// @ts-ignore
import { UpdateCompanyBranchCommand } from '../models';
/**
 * CompanyBranchApi - axios parameter creator
 * @export
 */
export const CompanyBranchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyBranchesGet: async (pageNumber?: number, pageSize?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/company-branches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyBranchesIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCompanyBranchesIdDelete', 'id', id)
            const localVarPath = `/api/company-branches/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyBranchesIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCompanyBranchesIdGet', 'id', id)
            const localVarPath = `/api/company-branches/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateCompanyBranchCommand} [updateCompanyBranchCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyBranchesIdPut: async (id: string, updateCompanyBranchCommand?: UpdateCompanyBranchCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCompanyBranchesIdPut', 'id', id)
            const localVarPath = `/api/company-branches/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCompanyBranchCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateCompanyBranchCommand} [createCompanyBranchCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyBranchesPost: async (createCompanyBranchCommand?: CreateCompanyBranchCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/company-branches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCompanyBranchCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyBranchApi - functional programming interface
 * @export
 */
export const CompanyBranchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompanyBranchApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyBranchesGet(pageNumber?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyBranchDtoPaginatedList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyBranchesGet(pageNumber, pageSize, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyBranchesIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyBranchesIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyBranchesIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyBranchDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyBranchesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateCompanyBranchCommand} [updateCompanyBranchCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyBranchesIdPut(id: string, updateCompanyBranchCommand?: UpdateCompanyBranchCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyBranchesIdPut(id, updateCompanyBranchCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateCompanyBranchCommand} [createCompanyBranchCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyBranchesPost(createCompanyBranchCommand?: CreateCompanyBranchCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyBranchesPost(createCompanyBranchCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CompanyBranchApi - factory interface
 * @export
 */
export const CompanyBranchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompanyBranchApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyBranchesGet(pageNumber?: number, pageSize?: number, search?: string, options?: any): AxiosPromise<CompanyBranchDtoPaginatedList> {
            return localVarFp.apiCompanyBranchesGet(pageNumber, pageSize, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyBranchesIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiCompanyBranchesIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyBranchesIdGet(id: string, options?: any): AxiosPromise<CompanyBranchDto> {
            return localVarFp.apiCompanyBranchesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateCompanyBranchCommand} [updateCompanyBranchCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyBranchesIdPut(id: string, updateCompanyBranchCommand?: UpdateCompanyBranchCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiCompanyBranchesIdPut(id, updateCompanyBranchCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateCompanyBranchCommand} [createCompanyBranchCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyBranchesPost(createCompanyBranchCommand?: CreateCompanyBranchCommand, options?: any): AxiosPromise<string> {
            return localVarFp.apiCompanyBranchesPost(createCompanyBranchCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiCompanyBranchesGet operation in CompanyBranchApi.
 * @export
 * @interface CompanyBranchApiApiCompanyBranchesGetRequest
 */
export interface CompanyBranchApiApiCompanyBranchesGetRequest {
    /**
     * 
     * @type {number}
     * @memberof CompanyBranchApiApiCompanyBranchesGet
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {number}
     * @memberof CompanyBranchApiApiCompanyBranchesGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof CompanyBranchApiApiCompanyBranchesGet
     */
    readonly search?: string
}

/**
 * Request parameters for apiCompanyBranchesIdDelete operation in CompanyBranchApi.
 * @export
 * @interface CompanyBranchApiApiCompanyBranchesIdDeleteRequest
 */
export interface CompanyBranchApiApiCompanyBranchesIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof CompanyBranchApiApiCompanyBranchesIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for apiCompanyBranchesIdGet operation in CompanyBranchApi.
 * @export
 * @interface CompanyBranchApiApiCompanyBranchesIdGetRequest
 */
export interface CompanyBranchApiApiCompanyBranchesIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CompanyBranchApiApiCompanyBranchesIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiCompanyBranchesIdPut operation in CompanyBranchApi.
 * @export
 * @interface CompanyBranchApiApiCompanyBranchesIdPutRequest
 */
export interface CompanyBranchApiApiCompanyBranchesIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof CompanyBranchApiApiCompanyBranchesIdPut
     */
    readonly id: string

    /**
     * 
     * @type {UpdateCompanyBranchCommand}
     * @memberof CompanyBranchApiApiCompanyBranchesIdPut
     */
    readonly updateCompanyBranchCommand?: UpdateCompanyBranchCommand
}

/**
 * Request parameters for apiCompanyBranchesPost operation in CompanyBranchApi.
 * @export
 * @interface CompanyBranchApiApiCompanyBranchesPostRequest
 */
export interface CompanyBranchApiApiCompanyBranchesPostRequest {
    /**
     * 
     * @type {CreateCompanyBranchCommand}
     * @memberof CompanyBranchApiApiCompanyBranchesPost
     */
    readonly createCompanyBranchCommand?: CreateCompanyBranchCommand
}

/**
 * CompanyBranchApi - object-oriented interface
 * @export
 * @class CompanyBranchApi
 * @extends {BaseAPI}
 */
export class CompanyBranchApi extends BaseAPI {
    /**
     * 
     * @param {CompanyBranchApiApiCompanyBranchesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyBranchApi
     */
    public apiCompanyBranchesGet(requestParameters: CompanyBranchApiApiCompanyBranchesGetRequest = {}, options?: AxiosRequestConfig) {
        return CompanyBranchApiFp(this.configuration).apiCompanyBranchesGet(requestParameters.pageNumber, requestParameters.pageSize, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompanyBranchApiApiCompanyBranchesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyBranchApi
     */
    public apiCompanyBranchesIdDelete(requestParameters: CompanyBranchApiApiCompanyBranchesIdDeleteRequest, options?: AxiosRequestConfig) {
        return CompanyBranchApiFp(this.configuration).apiCompanyBranchesIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompanyBranchApiApiCompanyBranchesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyBranchApi
     */
    public apiCompanyBranchesIdGet(requestParameters: CompanyBranchApiApiCompanyBranchesIdGetRequest, options?: AxiosRequestConfig) {
        return CompanyBranchApiFp(this.configuration).apiCompanyBranchesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompanyBranchApiApiCompanyBranchesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyBranchApi
     */
    public apiCompanyBranchesIdPut(requestParameters: CompanyBranchApiApiCompanyBranchesIdPutRequest, options?: AxiosRequestConfig) {
        return CompanyBranchApiFp(this.configuration).apiCompanyBranchesIdPut(requestParameters.id, requestParameters.updateCompanyBranchCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompanyBranchApiApiCompanyBranchesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyBranchApi
     */
    public apiCompanyBranchesPost(requestParameters: CompanyBranchApiApiCompanyBranchesPostRequest = {}, options?: AxiosRequestConfig) {
        return CompanyBranchApiFp(this.configuration).apiCompanyBranchesPost(requestParameters.createCompanyBranchCommand, options).then((request) => request(this.axios, this.basePath));
    }
}
